import { render, staticRenderFns } from "./PublicPowerBiVisual.vue?vue&type=template&id=489e722b&scoped=true"
import script from "./PublicPowerBiVisual.vue?vue&type=script&lang=js"
export * from "./PublicPowerBiVisual.vue?vue&type=script&lang=js"
import style0 from "./PublicPowerBiVisual.vue?vue&type=style&index=0&id=489e722b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e722b",
  null
  
)

export default component.exports